<script lang="ts">
    class Localizzazione {
        localizzazione: string;
        denominazione: string;
        comune: string;
        indirizzo: string;
        cap: string;

        constructor(init?: Localizzazione) {
            Object.assign(this, init);
        }
    }

    export let data: Localizzazione = new Localizzazione();

    function isAnyFieldSet(): boolean {
            return (data?.localizzazione !== '' || data?.localizzazione !== undefined ||
                    data?.denominazione !== '' || data?.denominazione !== undefined ||
                    data?.comune !== '' || data?.comune !== undefined ||
                    data?.indirizzo !== '' || data?.indirizzo !== undefined ||
                    data?.cap !== '' || data?.cap !== undefined
                    ) && Object.keys(data)?.length > 0;
        }
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="text-center border border-black">Localizzazione della sede</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.localizzazione || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Denominazione della sede</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.denominazione || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Comune</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.comune || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">Indirizzo e numero civico</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.indirizzo || '-'}</td>
        </tr>
        <tr>
            <td class="text-center border border-black">CAP</td>
            <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">{data?.cap || '-'}</td>
        </tr>
    </tbody>
</table>